import { rpApi } from "@/http";

export interface UserBadge {
  id?: string;
  ownerId?: string;
  badgeId?: string;
  badgeName?: string;
  badgeDescription?: string;
  badgeStyleType?: "DEFAULT" | "THREE_DIMENSION";
  attachmentLarge?: string;
  threeDimensionFileUrl?: string;
  availableAt?: string;
  disableAt?: string;
  availableAtText?: string;
  disableAtText?: string;
  isWearing?: boolean;
  url?: string;
}

export type BadgeAction = "WEARING" | "UN_WEARING";

export interface BadgeDetailResponse {
  code?: number | string;
  message?: string;
  data: { badge?: UserBadge };
}

type ApiPostResult = ReturnType<typeof rpApi.post>;

export default {
  getDetail(id: string, signal?: AbortSignal): Promise<BadgeDetailResponse> {
    return rpApi.post<{ badge?: UserBadge }>(
      "/gactus-web/v1/user_badge/detail",
      { id },
      { signal }
    );
  },
  action(params: {
    id: string;
    ownerId: string;
    action: BadgeAction;
  }): ApiPostResult {
    return rpApi.post("/gactus-web/badge/user-badge/action", params);
  },
};
